/**
 * 初筛相关状态常量
 * @description 定义初筛流程中的各种状态值
 */

/**
 * 初筛状态枚举
 * @description status字段：表示作品是否已经进行初筛
 */
export const INITIAL_SCREENING_STATUS = {
  /** 未初筛 */
  NOT_SCREENED: 0,
  /** 已初筛 */
  SCREENED: 1
}

/**
 * 推荐状态枚举
 * @description recommend_status字段：表示初筛的推荐结果
 */
export const RECOMMEND_STATUS = {
  /** 不推荐 */
  NOT_RECOMMENDED: 0,
  /** 推荐 */
  RECOMMENDED: 1,
  /** 未推荐 */
  UNRECOMMENDED: 2
}

/**
 * 获取初筛状态文本
 * @param {number} status - 初筛状态值
 * @returns {string} 状态文本
 */
export function getInitialScreeningStatusText(status) {
  switch (status) {
    case INITIAL_SCREENING_STATUS.NOT_SCREENED:
      return '未初筛'
    case INITIAL_SCREENING_STATUS.SCREENED:
      return '已初筛'
    default:
      return '未知状态'
  }
}

/**
 * 获取推荐状态文本
 * @param {number} status - 推荐状态值
 * @returns {string} 状态文本
 */
export function getRecommendStatusText(status) {
  switch (status) {
    case RECOMMEND_STATUS.NOT_RECOMMENDED:
      return '不推荐'
    case RECOMMEND_STATUS.RECOMMENDED:
      return '推荐'
    case RECOMMEND_STATUS.UNRECOMMENDED:
      return '未推荐'
    default:
      return '未设置'
  }
}

/**
 * 获取推荐状态样式
 * @param {number} status - 推荐状态值
 * @returns {string} 样式字符串
 */
export function getRecommendStatusStyle(status) {
  switch (status) {
    case RECOMMEND_STATUS.RECOMMENDED:
      return 'color: #52c41a;' // 绿色 - 推荐
    case RECOMMEND_STATUS.NOT_RECOMMENDED:
      return 'color: #ff4d4f;' // 红色 - 不推荐
    case RECOMMEND_STATUS.UNRECOMMENDED:
      return 'color: #fa8c16;' // 橙色 - 未推荐
    default:
      return ''
  }
}

/**
 * 获取推荐状态对应的初筛意见
 * @param {number} status - 推荐状态值
 * @returns {string} 初筛意见文本
 */
export function getRecommendStatusOpinion(status) {
  switch (status) {
    case RECOMMEND_STATUS.RECOMMENDED:
      return '推荐进入初审'
    case RECOMMEND_STATUS.NOT_RECOMMENDED:
      return '不推荐进入初审'
    case RECOMMEND_STATUS.UNRECOMMENDED:
      return '待初筛'
    default:
      return ''
  }
}
